import React from 'react';
import { Palette, Sofa, PenTool } from 'lucide-react';
import img1 from "../../assets/design1.jpg";
import img2 from "../../assets/design2.jpg";
import img3 from "../../assets/design3.jpg";
import img4 from "../../assets/design4.jpg";
import img5 from "../../assets/design5.jpg";

const designs = [
  { 
    id: 1, 
    title: 'Concept Mood Boards', 
    category: 'Planning', 
    image: img1 
  },
  { 
    id: 2, 
    title: 'Fabric & Material Selection', 
    category: 'Styling', 
    image: img2
  },
  { 
    id: 3, 
    title: '3D Visualization', 
    category: 'Digital', 
    image: img3 
  },
  { 
    id: 4, 
    title: 'Art Creation', 
    category: 'Decor', 
    image: img4 
  },
];

const InteriorDesigning = () => {
  return (
    <div className="font-sans text-gray-800 bg-white">
      {/* Hero */}
      <div
              className="relative h-[60vh] w-full bg-cover bg-center"
              style={{ backgroundImage: `url(${img5})` }}
            >
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
          <h4 className="text-amber-500 font-bold tracking-widest uppercase mb-3">The Soul of the Home</h4>
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-4">Interior Designing</h1>
          <p className="text-gray-200 text-lg max-w-xl">Curating spaces that reflect your personality and prestige.</p>
        </div>
      </div>

      {/* Intro */}
      <section className="py-16 px-6 bg-white text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4">From Concept to Reality</h2>
        <div className="w-20 h-1 bg-amber-500 mx-auto mb-6"></div>
        <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
          Our interior design service goes beyond decoration. We analyze your lifestyle, lighting, and spatial flow to create bespoke interiors. From selecting the perfect velvet for your sofa to placing the final art piece, we handle it all.
        </p>
      </section>

      {/* Gallery */}
      <section className="py-16 bg-gray-50 px-6">
        <div className="max-w-7xl mx-auto">
          <h3 className="text-3xl font-serif font-bold text-gray-900 mb-8 text-center md:text-left">Design Process</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {designs.map((item) => (
              <div key={item.id} className="group relative overflow-hidden shadow-lg cursor-pointer rounded-sm">
                <div className="h-80 overflow-hidden">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover transform group-hover:scale-110 transition duration-700"/>
                </div>
                <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/90 to-transparent p-6 pt-20">
                  <p className="text-amber-400 text-xs tracking-widest uppercase mb-1">{item.category}</p>
                  <h4 className="text-2xl font-serif text-white">{item.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 px-6 bg-stone-900 text-white">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="flex flex-col items-center">
            <Palette className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">Color Consultancy</h4>
            <p className="text-gray-400 text-sm">Expert advice on color palettes and textures.</p>
          </div>
          <div className="flex flex-col items-center">
            <Sofa className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">Custom Furniture</h4>
            <p className="text-gray-400 text-sm">Designing bespoke pieces that fit your space perfectly.</p>
          </div>
          <div className="flex flex-col items-center">
            <PenTool className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">Styling & Decor</h4>
            <p className="text-gray-400 text-sm">The final touches that make a house a home.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 text-center bg-white">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6">Transform Your Interiors</h2>
        <button className="bg-amber-500 hover:bg-amber-600 text-white text-lg font-semibold px-8 py-3 rounded-sm transition shadow-lg">Book Design Consultation</button>
      </section>
    </div>
  );
};

export default InteriorDesigning;